<script setup lang="ts">
withDefaults(
  defineProps<{
    display?: string
    maxClass?: string
    title?: string
    value: string
  }>(),
  {
    display: undefined,
    maxClass: "max-w-[12rem]",
    title: undefined
  }
)
</script>

<template>
  <UTooltip
    :content="{ side: 'top' }"
    :text="title ? `${title}: ${value}` : value"
    :ui="{ content: 'dashboard-tooltip-content', text: 'dashboard-tooltip-text' }"
  >
    <span
      class="dashboard-clipped-value dashboard-mono inline-block truncate align-bottom text-(--dash-ink)"
      :class="maxClass"
    >
      {{ display ?? value }}
    </span>
  </UTooltip>
</template>
